/* eslint-disable camelcase */
import { ServiceCart, ServiceItem } from '../../models';
import { GET_SERVICE_CART, RESET_SERVICE_CART } from '../constants/serviceCart';

const convertItem = (item, quantity, priceTotal, priceTotalWithFee, isAccepted) => {
  return new ServiceItem(
    item.id,
    item.name,
    item.price,
    item.price_with_fee,
    quantity,
    priceTotal,
    priceTotalWithFee,
    isAccepted,
  );
};

// eslint-disable-next-line import/prefer-default-export
export const getServiceCart = (data) => {
  const { service_cart } = data;
  if (!service_cart) {
    return (dispatch) => {
      dispatch({ type: RESET_SERVICE_CART });
    };
  }

  const { id, items, fee, total_price, total_price_with_fee } = service_cart;
  const convertedItems = items.map((element) => {
    const { item, quantity, item_price, item_price_with_fee, is_accepted } = element ?? {};
    return convertItem(item, quantity, item_price, item_price_with_fee, is_accepted);
  });

  const cart = new ServiceCart(id, convertedItems, total_price, fee, total_price_with_fee);
  return (dispatch) => {
    dispatch({
      type: GET_SERVICE_CART,
      ...cart,
    });
  };
};
